import { render, staticRenderFns } from "./newTopicAnswer.vue?vue&type=template&id=28f7b362"
import script from "./newTopicAnswer.vue?vue&type=script&lang=js"
export * from "./newTopicAnswer.vue?vue&type=script&lang=js"
import style0 from "./newTopicAnswer.vue?vue&type=style&index=0&id=28f7b362&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports